export default {
  UPLOADEDFILES ({ uploadedFiles }) {
    return uploadedFiles
  },
  CLIENT_DOWNLOAD_FILES ({ clientDownloadFiles }) {
    return clientDownloadFiles
  }
}
